import { AppStore } from 'app.store';
import { FeatureFlag } from 'core/enums/feature-flag';
import { PaymentApi } from 'core/services/api/payment/payment-api';
import { SubscriptionService } from 'core/services/api/subscriptions';
import RecurringPaymentStore from './recurring-payment.store';

class RecurringPaymentStoreManager {
  static async initializeFromAppContext(appContext: AppStore, update = false) {
    const { featureStore, recurringPaymentStore, customerNumber, countryName } = appContext;

    const hasRecurringPaymentFeature = featureStore.hasViewPermission(FeatureFlag.RecurringPaymentRoute);

    if (!hasRecurringPaymentFeature) {
      return;
    }

    return RecurringPaymentStoreManager.initialize(recurringPaymentStore, customerNumber, countryName, update);
  }

  static async initialize(store: RecurringPaymentStore, customerNumber: string, country: string, update = false) {
    if (store.isFetching || (!update && store.isInitialized)) {
      return;
    }

    if (update) {
      store.changeNeedToUpdate(true);
    }

    store.changeIsFetching(true)

    try {
      const [subs, result] = await Promise.all([
        SubscriptionService.getSubscriptions(customerNumber, country),
        new PaymentApi(customerNumber, country).getRecurringCustomer(true)
      ]);

      store.changeRecurringPaymentDetails(result);

      for (const sub of subs.subscriptions) {
        if (!sub?.services) {
          continue;
        }

        if (sub.services.some(x => x.status === "Active")) {
          store.changeHasConnectedService(true);
          break;
        }
      }
    } catch (error) {
      console.error('Error initializing RecurringPaymentStore', error);
      store.changeIsFetching(false);
    }
  }
}

export default RecurringPaymentStoreManager;